import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero__common__bg" }
const _hoisted_2 = {
  class: "solar",
  ref: "solar"
}
const _hoisted_3 = {
  class: "erin",
  ref: "erin"
}
const _hoisted_4 = {
  class: "wind",
  ref: "wind"
}
const _hoisted_5 = {
  class: "heroes",
  ref: "heroes"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512),
    _createElementVNode("div", _hoisted_3, null, 512),
    _createElementVNode("div", _hoisted_4, null, 512),
    _createElementVNode("div", _hoisted_5, null, 512)
  ]))
}